/**
 * Customall 变体按钮 → quantity-break 结构
 * 价格来自 window.customall_variants（由主题注入）
 */
(function () {
  var TRANSFORMED_ATTR = 'data-cm-qb-transformed';
  var VARIANT_ID_ATTR = 'data-cm-qb-variant-id';
  var ROOT_SELECTOR = '#personalized-form';
  var isTransforming = false;
  var BUY_MORE_LABEL = 'buy more save more';
  var BUY_MORE_ITEM_CLASS = 'quantity-break-section';
  var BUY_MORE_LABEL_CLASS = 'quantity-break__section-label';
  var BADGE_TEXTS = [
    '',
    '🔥 Most Popular',
    '🌟 Best Value + Highly Recommended',
    '🎁 Best Value'
  ];

  function getVariants() {
    return Array.isArray(window.customall_variants) ? window.customall_variants : [];
  }

  function formatMoney(cents) {
    var amount = Number(cents);
    if (!isFinite(amount)) return '';

    var format =
      (window.themeVariables &&
        window.themeVariables.settings &&
        window.themeVariables.settings.moneyFormat) ||
      '${{amount}}';

    var value = (amount / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    value = parts.join('.');

    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function normalizeKey(text) {
    return String(text || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function parseBuyQuantity(text) {
    var key = normalizeKey(text);
    var match = key.match(/^buy(\d+)$/);
    return match ? parseInt(match[1], 10) : null;
  }

  function parseQuantity(text) {
    var buyQty = parseBuyQuantity(text);
    if (buyQty !== null) return buyQty;

    var match = String(text || '').match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }

  function formatLabel(text) {
    return 'Buy ' + parseQuantity(text);
  }

  function getVariantOptionValues(variant) {
    if (Array.isArray(variant.options) && variant.options.length) {
      return variant.options.slice();
    }

    var values = [];
    if (variant.option1) values.push(variant.option1);
    if (variant.option2) values.push(variant.option2);
    if (variant.option3) values.push(variant.option3);
    return values;
  }

  function optionValueMatchesBuy(optionValue, buyKey, buyQty) {
    var candidateKey = normalizeKey(optionValue);
    if (!candidateKey) return false;
    if (candidateKey === buyKey) return true;
    return buyQty !== null && parseBuyQuantity(optionValue) === buyQty;
  }

  function variantMatchesBuyOption(variant, buyKey, buyQty) {
    var optionValues = getVariantOptionValues(variant);

    for (var i = 0; i < optionValues.length; i++) {
      if (optionValueMatchesBuy(optionValues[i], buyKey, buyQty)) {
        return true;
      }
    }

    return false;
  }

  function isBuyMoreFormItem(item) {
    var label = item && item.querySelector('label');
    return !!(
      label &&
      label.textContent.toLowerCase().indexOf(BUY_MORE_LABEL) !== -1
    );
  }

  function getSelectedOptionsFromForm(root, currentGroup) {
    var selected = [];

    if (!root) return selected;

    var items = root.querySelectorAll('.product-attributes .product-form__item');
    items.forEach(function (item) {
      if (currentGroup && item.contains(currentGroup)) return;
      if (isBuyMoreFormItem(item)) return;

      var activeBtn = item.querySelector(
        'button.active, button.btn-default.active, .buttons-group button.active'
      );
      if (activeBtn) {
        selected.push(normalizeKey(activeBtn.textContent));
      }
    });

    return selected;
  }

  function findVariant(buttonText, variants, root, currentGroup) {
    var buyKey = normalizeKey(buttonText);
    var buyQty = parseBuyQuantity(buttonText);
    if (!buyKey) return null;

    var matches = [];
    for (var i = 0; i < variants.length; i++) {
      if (variantMatchesBuyOption(variants[i], buyKey, buyQty)) {
        matches.push(variants[i]);
      }
    }

    if (!matches.length) return null;
    if (matches.length === 1) return matches[0];

    var selectedOther = getSelectedOptionsFromForm(root, currentGroup);
    if (selectedOther.length) {
      for (var m = 0; m < matches.length; m++) {
        var variant = matches[m];
        var optionKeys = getVariantOptionValues(variant).map(normalizeKey);
        var fitsAll = selectedOther.every(function (sel) {
          return optionKeys.indexOf(sel) !== -1;
        });
        if (fitsAll) return variant;
      }
    }

    return matches[0];
  }

  function getBuyMoreSection(group) {
    var formItem = group.closest('.product-form__item');
    if (!formItem) return null;

    var label = formItem.querySelector('label');
    if (!label) return null;
    if (label.textContent.toLowerCase().indexOf(BUY_MORE_LABEL) === -1) return null;

    return { formItem: formItem, label: label };
  }

  function isBuyMoreSaveMoreGroup(group) {
    return !!getBuyMoreSection(group);
  }

  function markBuyMoreSection(group) {
    var section = getBuyMoreSection(group);
    if (!section) return;

    section.formItem.classList.add(BUY_MORE_ITEM_CLASS);
    section.label.classList.add(BUY_MORE_LABEL_CLASS);
  }

  function getBuyLabelSource(variant, buttonText) {
    var buyQty = parseBuyQuantity(buttonText);
    var optionValues = getVariantOptionValues(variant);

    for (var i = 0; i < optionValues.length; i++) {
      if (parseBuyQuantity(optionValues[i]) === buyQty) {
        return optionValues[i];
      }
    }

    return buttonText;
  }

  function buildButtonContent(variant, buttonIndex, buttonText) {
    var labelSource = getBuyLabelSource(variant, buttonText);
    var quantity = parseQuantity(labelSource);
    var price = Number(variant.price) || 0;
    var compareAt = Number(variant.compare_at_price) || 0;
    var eachPrice = quantity > 0 ? Math.round(price / quantity) : price;

    var compareHtml =
      compareAt > price
        ? '<span class="quantity-break__compare-price"><span>' +
          formatMoney(compareAt) +
          '</span></span>'
        : '';

    var captionHtml =
      quantity > 1
        ? '<span class="quantity-break__caption">Only ' +
          formatMoney(eachPrice) +
          ' each</span>'
        : '';

    var badgeText = BADGE_TEXTS[buttonIndex] || '';
    var badgeHtml = badgeText
      ? '<p class="quantity-break__badge">' + badgeText + '</p>'
      : '';

    return (
      badgeHtml +
      '<div class="quantity-break__image-and-content">' +
      '<div class="quantity-break__content">' +
      '<div class="quantity-break__left">' +
      '<span class="quantity-break__label">' +
      '<span class="quantity-break__label-text">' +
      formatLabel(labelSource) +
      '</span>' +
      '</span>' +
      captionHtml +
      '</div>' +
      '<div class="quantity-break__right">' +
      '<span class="quantity-break__price"><span>' +
      formatMoney(price) +
      '</span></span>' +
      compareHtml +
      '</div>' +
      '</div>' +
      '</div>'
    );
  }

  function transformButton(button, variants, buttonIndex, root, currentGroup) {
    if (!button.hasAttribute('data-cm-qb-buy-key')) {
      button.setAttribute('data-cm-qb-buy-key', normalizeKey(button.textContent));
    }

    var buyKey = button.getAttribute('data-cm-qb-buy-key');
    var variant = findVariant(buyKey, variants, root, currentGroup);
    if (!variant) return false;

    var variantId = String(variant.id);
    if (
      button.getAttribute(TRANSFORMED_ATTR) === 'true' &&
      button.getAttribute(VARIANT_ID_ATTR) === variantId
    ) {
      return true;
    }

    button.classList.add('quantity-break');
    button.innerHTML = buildButtonContent(variant, buttonIndex, buyKey);
    button.setAttribute(TRANSFORMED_ATTR, 'true');
    button.setAttribute(VARIANT_ID_ATTR, variantId);
    return true;
  }

  function transformButtonsGroup(group, variants, root) {
    if (!group || !isBuyMoreSaveMoreGroup(group)) return false;

    markBuyMoreSection(group);

    var buttons = group.querySelectorAll('button');
    if (!buttons.length) return false;

    var transformed = 0;
    buttons.forEach(function (button, index) {
      if (transformButton(button, variants, index, root, group)) {
        transformed++;
      }
    });

    if (transformed > 0) {
      group.classList.add('quantity-break-group');
      group.setAttribute(TRANSFORMED_ATTR, 'true');
      return transformed === buttons.length;
    }

    return false;
  }

  function transformAll(root) {
    var variants = getVariants();
    if (!root || !variants.length) return false;

    var groups = root.querySelectorAll('.product-attributes .buttons-group');
    if (!groups.length) return false;

    var didTransform = false;
    var allComplete = true;

    groups.forEach(function (group) {
      var ok = transformButtonsGroup(group, variants, root);
      if (ok) {
        didTransform = true;
      } else if (isBuyMoreSaveMoreGroup(group)) {
        allComplete = false;
      }
    });

    return didTransform && allComplete;
  }

  function isBuyMoreReady() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    if (!getVariants().length) return false;

    var groups = root.querySelectorAll('.product-attributes .buttons-group');
    for (var i = 0; i < groups.length; i++) {
      if (isBuyMoreSaveMoreGroup(groups[i])) {
        return groups[i].querySelectorAll('button').length > 0;
      }
    }

    return false;
  }

  function isMutationFromUs(mutation) {
    var el = mutation.target;
    if (el && el.nodeType === 3) el = el.parentElement;
    if (!el || !el.closest) return false;
    return !!el.closest('[data-cm-qb-transformed="true"]');
  }

  function shouldReactToMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (!isMutationFromUs(mutations[i])) return true;
    }
    return false;
  }

  function scheduleTransform(run) {
    clearTimeout(scheduleTransform._timer);
    scheduleTransform._timer = setTimeout(run, 50);
  }

  function runTransform() {
    if (isTransforming) return false;

    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;

    isTransforming = true;
    try {
      return transformAll(root);
    } finally {
      isTransforming = false;
    }
  }

  function attachOptionListeners(root) {
    if (root.getAttribute('data-cm-qb-listeners') === 'true') return;
    root.setAttribute('data-cm-qb-listeners', 'true');

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('.product-attributes .product-form__item button');
      if (!btn || !root.contains(btn)) return;

      var formItem = btn.closest('.product-form__item');
      if (isBuyMoreFormItem(formItem)) return;

      scheduleTransform(runTransform);
    });
  }

  function boot() {
    if (window.__cmQuantityBreakBooted) return;
    window.__cmQuantityBreakBooted = true;

    var rootObserverAttached = false;
    var rootObserver;
    var formObserver;
    var schedule;

    function attachFormObserver(root) {
      if (!root || root.getAttribute('data-cm-qb-observer') === 'true') return;
      root.setAttribute('data-cm-qb-observer', 'true');

      attachOptionListeners(root);

      formObserver = new MutationObserver(function (mutations) {
        if (!shouldReactToMutations(mutations)) return;
        clearTimeout(schedule);
        schedule = setTimeout(runTransform, 150);
      });

      formObserver.observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    function onReady() {
      var root = document.querySelector(ROOT_SELECTOR);

      if (root) {
        attachFormObserver(root);
        runTransform();
        return;
      }

      if (rootObserverAttached) return;
      rootObserverAttached = true;

      rootObserver = new MutationObserver(function () {
        var nextRoot = document.querySelector(ROOT_SELECTOR);
        if (!nextRoot) return;

        rootObserver.disconnect();
        attachFormObserver(nextRoot);
        runTransform();
      });

      rootObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    function tick() {
      if (isBuyMoreReady() && runTransform()) return true;
      onReady();
      return false;
    }

    tick();

    var retries = 0;
    var retryTimer = setInterval(function () {
      if (tick()) {
        clearInterval(retryTimer);
        return;
      }
      retries++;
      if (retries >= 120) {
        clearInterval(retryTimer);
      }
    }, 500);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tick);
    }

    window.addEventListener('load', tick);
  }

  window.cmQuantityBreak = {
    run: runTransform,
    getVariants: getVariants
  };

  boot();
})();
